import React from 'react';
import { CompoundInterestSummaryHeroMetric } from './metric/compound-interest-summary-hero-metric';

interface CompoundInterestSummaryHeroProps {
    finalValueLabel: React.ReactNode;
    finalValue: React.ReactNode;
    totalInvestedLabel: React.ReactNode;
    totalInvested: React.ReactNode;
    profitAfterTaxLabel: React.ReactNode;
    profitAfterTax: React.ReactNode;
}

export const CompoundInterestSummaryHero: React.FC<CompoundInterestSummaryHeroProps> = ({
    finalValueLabel,
    finalValue,
    totalInvestedLabel,
    totalInvested,
    profitAfterTaxLabel,
    profitAfterTax,
}) => (
    <div className="overflow-hidden rounded-t-[2.8rem] border border-[#d9cdc5] bg-[linear-gradient(180deg,#e9dfd6_0%,#f4ece5_55%,#fdf7f2_100%)] text-brand-secondary md:rounded-t-[3.6rem]">
        <div className="grid grid-cols-1 items-stretch [@media(min-width:1100px)]:grid-cols-3">
            <CompoundInterestSummaryHeroMetric label={finalValueLabel} value={finalValue} featured />
            <CompoundInterestSummaryHeroMetric label={totalInvestedLabel} value={totalInvested} />
            <CompoundInterestSummaryHeroMetric label={profitAfterTaxLabel} value={profitAfterTax} />
        </div>
    </div>
);
